module.exports = __webpack_public_path__ + "img/Logo.17373c03.png";